//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import UserId from '@models/UserId';
import { sessionFetch } from '@utils/sessionFetch';

import {
  IClientDto,
  ICreateUserDto,
  ISettingsUser,
  IUserAndPassword,
  IUserInfo,
} from './teamManagementApiModel';
function settingsFetch(endpoint: string, init?: RequestInit) {
  return sessionFetch(`/api/settings${endpoint}`, init);
}

export async function addUser(user: ICreateUserDto): Promise<IUserAndPassword> {
  const res = await settingsFetch(`/users`, {
    method: 'POST',
    body: JSON.stringify(user),
  });
  return res.json();
}

export async function deleteUser(userId: UserId): Promise<void> {
  await settingsFetch(`/users/${userId}`, { method: 'DELETE' });
}

export async function getAllClients(): Promise<IClientDto[]> {
  const res = await settingsFetch(`/clients`);
  return res.json();
}

/**
 * Get all users associated with the current client
 *
 * @returns If the user is an admin, returns full user details. Otherwise, only returns basic details
 */
export async function getAllUsers(
  init: RequestInit = {},
): Promise<ISettingsUser[] | IUserInfo[]> {
  const res = await settingsFetch(`/users`, init);
  return res.json();
}

export async function getUser(userId: UserId): Promise<ISettingsUser> {
  const res = await settingsFetch(`/users/${userId}`);
  return res.json();
}

export async function updateUser(user: ISettingsUser): Promise<ISettingsUser> {
  const res = await settingsFetch(`/users/${user.id}`, {
    method: 'PUT',
    body: JSON.stringify(user),
  });
  return res.json();
}
